import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import {
  formatarMoedaIMask,
  formatarPorcentagem,
} from '../../../../../../helpers/formatador';
import { Card, TextCard, TextCardColor, TitleCard } from './styles';

export default function ParametroValores({ icms, tarifaTmov, pedagio }) {
  return (
    <>
      <Col span={24} style={{ marginBottom: 16 }}>
        <Card bordered={true}>
          <TitleCard>Parâmetros de valores</TitleCard>
          <Row justify="space-between">
            <Col>
              <TextCard>Pedágio</TextCard>
              <br />
              <TextCardColor>{`${formatarMoedaIMask(pedagio)}`}</TextCardColor>
            </Col>
            <Col>
              <TextCard>ICMS</TextCard>
              <br />
              <TextCardColor>{`${formatarPorcentagem(icms)}`}</TextCardColor>
            </Col>
            <Col>
              <TextCard>Tarifa TMOV</TextCard>
              <br />
              <TextCardColor>
                {`${formatarMoedaIMask(tarifaTmov)} /ton`}
              </TextCardColor>
            </Col>
          </Row>
        </Card>
      </Col>
    </>
  );
}

ParametroValores.propTypes = {
  pedagio: PropTypes.number.isRequired,
  icms: PropTypes.number.isRequired,
  tarifaTmov: PropTypes.number,
};

ParametroValores.defaultProps = {
  tarifaTmov: 0,
};
